import {
  TrackingMethod,
  type TrackingMethod as TrackingMethodType,
  TrackingProvider,
  type TrackingProvider as TrackingProviderType,
} from './Tracking'

export type PreferredTrackingMethod = {
  provider?: TrackingProviderType
  method?: TrackingMethodType
}

export function getProvidersForMethod(method?: TrackingMethod) {
  switch (method) {
    case TrackingMethod.ELD:
    case TrackingMethod.Mobile:
      return [TrackingProvider.TT, TrackingProvider.MACROPOINT]
    case TrackingMethod.API:
      return [TrackingProvider.MACROPOINT]
    case TrackingMethod.EDI:
    default:
      return []
  }
}
